// https://github.com/vitejs/vite/issues/2139#issuecomment-802981228
// This workaround handles the rollup problem with CommonJS exports

import original from "react-outside-click-handler";

const OutsideClickHandler = original.default ? original.default : original;
export default OutsideClickHandler;
